<template>
  <div class="system-config-container">
    <div class="card config-card">
      <div class="card-header">
        <span>系统配置管理</span>
        <button 
          class="primary-button"
          @click="saveConfig"
          :disabled="isSaving"
        >
          <span v-if="isSaving" class="loading-spinner"></span>
          {{ isSaving ? '保存中...' : '保存配置' }}
        </button>
      </div>

      <form 
        @submit.prevent="saveConfig"
        class="config-form"
      >
        <!-- 系统配置 -->
        <div class="divider">
          <span>第三方登录配置</span>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label" for="gf_config">广发cookie</label>
            <textarea
              id="gf_config"
              v-model="configForm.gf_config"
              class="form-textarea"
              rows="10"
              placeholder="请输入广发cookie"
              :class="{ 'error': errors.gf_config }"
              @blur="validateField('gf_config')"
            ></textarea>
            <div v-if="errors.gf_config" class="error-message">{{ errors.gf_config }}</div>
          </div>

          

          <div class="form-item">
            <label class="form-label" for="zxzz_config">中信中证配置</label>
            <textarea
              id="zxzz_config"
              v-model="configForm.zxzz_config"
              class="form-textarea"
              rows="10"
              placeholder="请输入中信中证配置"
              :class="{ 'error': errors.zxzz_config }"
              @blur="validateField('zxzz_config')"
            ></textarea>
            <div v-if="errors.zxzz_config" class="error-message">{{ errors.zxzz_config }}</div>
          </div>
          
          <div class="form-item">
            <label class="form-label" for="zzzq_config">中信证券配置</label>
            <textarea
              id="zzzq_config"
              v-model="configForm.zzzq_config"
              class="form-textarea"
              rows="10"
              placeholder="请输入中信证券配置"
              :class="{ 'error': errors.zzzq_config }"
              @blur="validateField('zzzq_config')"
            ></textarea>
            <div v-if="errors.zzzq_config" class="error-message">{{ errors.zzzq_config }}</div>
          </div>

          <div class="form-item">
            <label class="form-label" for="kpl_config">开盘啦配置</label>
            <textarea
              id="kpl_config"
              v-model="configForm.kpl_config"
              class="form-textarea"
              rows="10"
              placeholder="请输入开盘啦配置"
              :class="{ 'error': errors.kpl_config }"
              @blur="validateField('kpl_config')"
            ></textarea>
            <div v-if="errors.kpl_config" class="error-message">{{ errors.kpl_config }}</div>
          </div>

          <div class="form-item">
            <label class="form-label" for="tushare_config">Tushare配置</label>
            <textarea
              id="tushare_config"
              v-model="configForm.tushare_config"
              class="form-textarea"
              rows="10"
              placeholder="请输入Tushare配置"
              :class="{ 'error': errors.tushare_config }"
              @blur="validateField('tushare_config')"
            ></textarea>
            <div v-if="errors.tushare_config" class="error-message">{{ errors.tushare_config }}</div>
          </div>
          <div class="form-item">
            <label class="form-label" for="feishu_config">飞书配置</label>
            <textarea
              id="feishu_config"
              v-model="configForm.feishu_config"
              class="form-textarea"
              rows="10"
              placeholder="请输入飞书配置"
              :class="{ 'error': errors.feishu_config }"
              @blur="validateField('feishu_config')"
            ></textarea>
            <div v-if="errors.feishu_config" class="error-message">{{ errors.feishu_config }}</div>
          </div>
          <div class="form-item">
            <label class="form-label" for="zj_config">中金配置</label>
            <textarea
              id="zj_config"
              v-model="configForm.zj_config"
              class="form-textarea"
              rows="15"
              placeholder="请输入中金配置"
              :class="{ 'error': errors.zj_config }"
              @blur="validateField('zj_config')"
            ></textarea>
            <div v-if="errors.zj_config" class="error-message">{{ errors.zj_config }}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus' // 暂时保留消息提示，后面可以替换
import { getSystemConfig, updateSystemConfig } from '@/api/system'

const isSaving = ref(false)
const isLoading = ref(false)

// 优化数据模型：只保留实际使用的字段
const configForm = reactive({
  gf_config: '',
  zzzq_config: '',
  kpl_config: '',
  tushare_config: '',
  feishu_config: '',
  zj_config: '',
  zxzz_config: ''
})

// 错误信息
const errors = reactive({
  gf_config: '',
  zzzq_config: '',
  kpl_config: '',
  tushare_config: '',
  feishu_config: '',
  zj_config: '',
  zxzz_config: ''
})

// 验证规则
const validateField = (field) => {
  switch (field) {
    case 'gf_config':
      if (!configForm.gf_config.trim()) {
        errors.gf_config = '请输入广发配置'
        return false
      }
      if (configForm.gf_config.length < 10) {
        errors.gf_config = 'cookie长度不能少于10个字符'
        return false
      }
      errors.gf_config = ''
      return true
    case 'zxzz_config':
      if (!configForm.zxzz_config.trim()) {
        errors.zxzz_config = '请输入中信中证配置'
        return false
      }
      if (configForm.zxzz_config.length < 5) {
        errors.zxzz_config = '配置长度不能少于5个字符'
        return false
      }
      errors.zxzz_config = ''
      return true
    case 'zzzq_config':
      if (!configForm.zzzq_config.trim()) {
        errors.zzzq_config = '请输入中信证券配置'
        return false
      }
      if (configForm.zzzq_config.length < 5) {
        errors.zzzq_config = '配置长度不能少于5个字符'
        return false
      }
      errors.zzzq_config = ''
      return true
      case 'kpl_config':
      if (!configForm.kpl_config.trim()) {
        errors.kpl_config = '请输入开盘啦配置'
        return false
      }
      if (configForm.kpl_config.length < 10) {
        errors.kpl_config = 'cookie长度不能少于10个字符'
        return false
      }
      errors.kpl_config = ''
      return true
    case 'tushare_config':
      if (!configForm.tushare_config.trim()) {
        errors.tushare_config = '请输入Tushare配置'
        return false
      }
      if (configForm.tushare_config.length < 10) {
        errors.tushare_config = 'cookie长度不能少于10个字符'
        return false
      }
      errors.tushare_config = ''
      return true
     case 'feishu_config':
      if (!configForm.feishu_config.trim()) {
        errors.feishu_config = '请输入Feishu配置'
        return false
      }
      if (configForm.feishu_config.length < 10) {
        errors.feishu_config = 'cookie长度不能少于10个字符'
        return false
      }
      errors.feishu_config = ''
      return true
    case 'zj_config':
      if (!configForm.zj_config.trim()) {
        errors.zj_config = '请输入中金配置'
        return false
      }
      if (configForm.zj_config.length < 10) {
        errors.zj_config = 'cookie长度不能少于10个字符'
        return false
      }
      errors.zj_config = ''
      return true
    default:
      return true
  }
}

// 验证整个表单
const validateForm = () => {
  let isValid = true
  for (const field in configForm) {
    if (!validateField(field)) {
      isValid = false
    }
  }
  return isValid
}

// 获取系统配置
const fetchConfig = async () => {
  if (isLoading.value) return
  
  isLoading.value = true
  try {
    const response = await getSystemConfig()
    
    // 打印完整响应以便调试
    console.log('完整响应:', response)
    
    // 检查响应格式
    if (response.status === 200 && response.data) {
      const data = response.data
      
      // 确保是预期的响应格式
      if (data.code === 200 && data.data) {
        // 只赋值存在的字段，避免覆盖默认值
        if (data.data.gf_config !== undefined) {
          configForm.gf_config = data.data.gf_config
          console.log('成功赋值gf_config:', configForm.gf_config)
        }

        if (data.data.zzzq_config !== undefined) {
          // 尝试将字符串格式的cookies解析为对象
          try {
            if (typeof data.data.zzzq_config === 'string' && data.data.zzzq_config.trim()) {
              configForm.zzzq_config = data.data.zzzq_config
            } else {
              configForm.zzzq_config = data.data.zzzq_config
            }
          } catch (error) {
            console.warn('zzzq_cookies解析失败，使用原始值:', error)
            configForm.zzzq_config = data.data.zzzq_config
          }
          console.log('成功赋值zzzq_config:', configForm.zzzq_config)
        }
        if (data.data.zxzz_config !== undefined) {
          // 尝试将字符串格式的cookies解析为对象
          try {
            if (typeof data.data.zxzz_config === 'string' && data.data.zxzz_config.trim()) {
              configForm.zxzz_config = data.data.zxzz_config
            } else {
              configForm.zxzz_config = data.data.zxzz_config
            }
          } catch (error) {
            console.warn('zxzz_config解析失败，使用原始值:', error)
            configForm.zxzz_config = data.data.zxzz_config
          }
          console.log('成功赋值zxzz_config:', configForm.zxzz_config)
        }
        if (data.data.kpl_config !== undefined) {
          configForm.kpl_config = data.data.kpl_config
          console.log('成功赋值kpl_config:', configForm.kpl_config)
        }
        if (data.data.tushare_config !== undefined) {
          configForm.tushare_config = data.data.tushare_config
          console.log('成功赋值tushare_config:', configForm.tushare_config)
        }
        if (data.data.feishu_config !== undefined) {
          configForm.feishu_config = data.data.feishu_config
          console.log('成功赋值feishu_config:', configForm.feishu_config)
        }
        if (data.data.zj_config !== undefined) {
          configForm.zj_config = data.data.zj_config
          console.log('成功赋值zj_config:', configForm.zj_config)
        }
        ElMessage.success('配置加载成功')
      } else {
        ElMessage.warning('未获取到配置，使用默认值')
        console.warn('响应格式不正确:', data)
      }
    } else {
      ElMessage.warning('未获取到配置，使用默认值')
      console.warn('请求未返回预期数据')
    }
  } catch (error) {
    // 捕获并处理所有错误
    console.error('获取配置失败:', error)
    
    // 安全地访问错误信息
    const errorMessage = error.response?.data?.message || error.message || '未知错误'
    ElMessage.error(`获取配置失败: ${errorMessage}`)
  } finally {
    isLoading.value = false
  }
}

// 保存系统配置
const saveConfig = async () => {
  if (isSaving.value) return
  
  try {
    if (!validateForm()) {
      return
    }
    
    isSaving.value = true
    
    // 准备发送的数据，将zzzq_config转换为JSON字符串
    const dataToSend = {
      gf_config: configForm.gf_config,
      zzzq_config:configForm.zzzq_config,
      kpl_config: configForm.kpl_config,
      tushare_config: configForm.tushare_config,
      feishu_config: configForm.feishu_config,
      zj_config: configForm.zj_config,
      zxzz_config: configForm.zxzz_config
    }
    
    const response = await updateSystemConfig(dataToSend)
    
    if (response.data.code === 200) {
      ElMessage.success('配置保存成功')
    } else {
      ElMessage.error(`配置保存失败: ${response.data.message || '未知错误'}`)
    }
  } catch (error) {
    console.error('保存配置失败:', error)
    ElMessage.error(`配置保存失败: ${error.message || '未知错误'}`)
  } finally {
    isSaving.value = false
  }
}

// 组件挂载时获取配置
onMounted(() => {
  fetchConfig()
})
</script>

<style scoped>
.system-config-container {
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.card {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 800px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.card-header span {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.primary-button {
  background-color: #409eff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s;
}

.primary-button:hover:not(:disabled) {
  background-color: #66b1ff;
}

.primary-button:disabled {
  background-color: #a0cfff;
  cursor: not-allowed;
}

.loading-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.config-form {
  width: 100%;
}

.divider {
  display: flex;
  align-items: center;
  margin: 20px 0;
  color: #606266;
  font-size: 14px;
}

.divider:before,
.divider:after {
  content: '';
  flex: 1;
  height: 1px;
  background: #ebeef5;
}

.divider:before {
  margin-right: 10px;
}

.divider:after {
  margin-left: 10px;
}

.form-row {
  margin-bottom: 20px;
}

.form-item {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  color: #606266;
  font-size: 14px;
  font-weight: 500;
  width: 120px;
}

.form-textarea {
  width: 100%;
  min-height: 100px;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  resize: vertical;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.form-textarea:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.form-textarea.error {
  border-color: #f56c6c;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 4px;
}
</style>